import { Modal } from 'antd';

export function ModalUpgrade(){
    return Modal.confirm({
        title: 'Upgrade to Pro Version',
        content: "This functionality is exclusive to the pro version.",
        okText: 'More Information',
        cancelText: 'Close',
        onOk : function(){
          window.open('https://www.magnumleap.com/en#pricing', '_blank');
        },
        onCancel : function(){
        }
    });
}


// WEBPACK FOOTER //
// ./src/Frontend/components/LiteComponents.js